// TODO: consume it from stores API -
// https://github.com/wix-private/wixstores-storefront/blob/298b907fefaf525a98cfd9c2367373834d47cbbd/packages/wixstores-client-product-page/src/productPage/constants.ts#L42
export let ProductPageLayoutType = /*#__PURE__*/function (ProductPageLayoutType) {
  ProductPageLayoutType[ProductPageLayoutType["EmptyState"] = 0] = "EmptyState";
  ProductPageLayoutType[ProductPageLayoutType["Classic"] = 1] = "Classic";
  ProductPageLayoutType[ProductPageLayoutType["QuickView"] = 2] = "QuickView";
  ProductPageLayoutType[ProductPageLayoutType["Sleek"] = 4] = "Sleek";
  ProductPageLayoutType[ProductPageLayoutType["Stunning"] = 5] = "Stunning";
  ProductPageLayoutType[ProductPageLayoutType["Spotlight"] = 6] = "Spotlight";
  ProductPageLayoutType[ProductPageLayoutType["Simple"] = 7] = "Simple";
  ProductPageLayoutType[ProductPageLayoutType["Responsive"] = 8] = "Responsive";
  return ProductPageLayoutType;
}({});

// TODO: consume it from stores API
export let CategoryPageLayoutType = /*#__PURE__*/function (CategoryPageLayoutType) {
  CategoryPageLayoutType[CategoryPageLayoutType["Inline"] = 0] = "Inline";
  CategoryPageLayoutType[CategoryPageLayoutType["Top"] = 1] = "Top";
  return CategoryPageLayoutType;
}({});
export const WIDGET_IDS = {
  CATEGORY_PAGE: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
  PRODUCT_PAGE: '13a94f09-2766-3c40-4a32-8edb5acdd8bc'
};
export const CATEGORY_PAGE = {
  accessibleValue: CategoryPageLayoutType.Top,
  defaultValue: CategoryPageLayoutType.Inline,
  styleParam: 'param_number_gallery_categoryHeaderPosition',
  widgetId: WIDGET_IDS.CATEGORY_PAGE
};
export const PRODUCT_PAGE = {
  accessibleValue: ProductPageLayoutType.Spotlight,
  defaultValue: ProductPageLayoutType.Classic,
  styleParam: 'param_number_productPage_layoutId',
  widgetId: WIDGET_IDS.PRODUCT_PAGE
};
//# sourceMappingURL=constants.js.map